export default {
  'data_validator': {
    'required': 'O campo %name% não pode estar vazio',
    'min_length': 'O campo %name% deve ter um mínimo de caracteres %length%',
    'max_length': 'O campo %name% pode ter um máximo de caracteres %length%',
    'type': 'O campo %name% tem um formato incorreto',
    'invalid_option': 'A opção selecionada no campo %name% é inválida',
    'numeric': {
      'smaller_than': 'O campo %name% deve ser inferior a %number%',
      'greather_than': 'O campo %name% deve ser maior que %number%'
    },
    'date': {
      'smaller_than': 'A data no campo %name% deve ser inferior à data de encerramento',
      'greather_than': 'A data no campo %name% deve ser maior que a data de início'
    },
    'file': {
      'format': 'O arquivo que você está tentando enviar tem um formato incorreto (formatos permitidos %formatos%)',
      'size': 'O arquivo que você está tentando enviar é muito pesado (peso máximo de %size% mb)'
    }
  },
  'calendar': {
    'month_names': {
      'january': 'JAN',
      'february': 'FEV',
      'march': 'MAR',
      'april': 'ABR',
      'may': 'MAI',
      'june': 'JUN',
      'july': 'JUL',
      'august': 'AGO',
      'september': 'SET',
      'october': 'OUT',
      'november': 'NOV',
      'december': 'DEZ'
    },
    'day_names_short': {
      'sunday': 'D',
      'monday': '2f',
      'tuesday': '3f',
      'wednesday': '4f',
      'thursday': '5f',
      'friday': '6f',
      'saturday': 'S'
    }
  },
  'errors': {
    'parse': {
      '101': 'O usuário ou senha son incorretos'
    },
    'custom': {
      '001': 'Ocorreu um erro ao enviar o pedido, por favor, pedimos que tente depois',
      '002': 'O código do cliente pertence a outro cliente, insira outro código',
      '003': 'O usuário do vendedor não existe',
      '004': 'O campo do usuário do vendedor está vazio',
      '005': 'O campo de código do cliente está vazio',
      '006': 'Você não possui permissões suficientes para acessar',
      '007': 'CIF do cliente pertence a outro cliente, insira outro CIF',
      '008': 'A data selecionada é inválida, verifique',
      '009': 'O email inserido já está em uso',
      '010': 'Selecione pelo menos uma marca da {brand} antes de escolher os materiais do MTKG',
      '011': 'Não há PDF para exportar para o mês e ano indicados.',
      '012': 'Para esta ação, você deve primeiro selecionar o cliente',
      '013': 'Você deve selecionar pelo menos uma marca',
      '014': 'Deve indicar pelo menos um valor em uma das marcas',
      '015': 'Você deve indicar ano e mês para continuar com a operação',
      '016': 'Já existe um arquivo com este código de cliente',
      '017': 'O usuário inserido já está em uso'
    }
  },
  'views_names': {
    'public': {
      'login': 'Iniciar sessão'
    },
    'private': {
      'sellers': {
        'list': 'Vendedores',
        'create': 'Vendedores',
        'delegations': 'Vendedores',
        'types': 'Vendedores'
      },
      'clients': {
        'list': 'Clientes'
      },
      'clients_records': {
        'list': 'Ficha Cliente'
      },
      'contracts': {
        'list': 'Contratos',
        'sda': 'Contratos',
        'history': 'Histórico',
        'zips': 'Zips'
      },
      'reports': {
        'master_data': 'Relatórios',
        'sda': 'Relatórios',
        'potential': 'Relatórios',
        'cci': 'Relatórios',
        'education': 'Relatórios'
      },
      'history': {
        'contracts': 'Histórico - Contratos',
        'sda': 'Histórico - Contratos SDA'
      }
    }
  },
  'public': {
    'login': {
      'title': 'Iniciar sessão | Wella',
      'fields': {
        'username': 'usuário',
        'password': 'senha'
      },
      'login_button': 'Iniciar sessão'
    }
  },
  'private': {
    'header': {
      'options': 'Opções'
    },
    'aside': {
      'sellers': 'Vendedores',
      'clients': 'Clientes',
      'clients_records': 'Ficha Cliente',
      'contracts': 'Contratos',
      'reports': 'Relatórios',
      'history': 'Histórico',
      'logout': 'Sair'
    },
    'sellers': {
      'header': {
        'sellers_list': 'Listagem',
        'sellers_delegations': 'Delegações',
        'sellers_types': 'Tipos'
      },
      'list': {
        'sellers_list': 'Lista de vendedores',
        'create_seller': 'Criar vendedor',
        'see_filters': 'Veja filtros',
        'export_users': 'Exportadores',
        'please_wait': 'Aguarde um momento',
        'filters': {
          'fullname': 'Nome ou sobrenome',
          'username': 'Nome de usuário',
          'email': 'Correio eletrônico',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'firstname': 'Nomes',
            'lastname': 'Sobrenome'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'firstname': 'Nomes',
          'lastname': 'Sobrenome',
          'username': 'Usuário',
          'email': 'Correio eletrônico',
          'delegation': 'Delegação',
          'type': 'Tipo',
          'active': 'Ativo',
          'multi_type': 'Multimarca',
          'active_yes': 'Sim',
          'active_no': 'Não',
          'last_access': 'Último acesso'
        },
        'menu_more_options': {
          'edit_seller': 'Editar vendedor',
          'delete_seller': 'Remover vendedor'
        },
        'sellers_list_create': 'Criar vendedor',
        'fields': {
          'firstname': 'Nomes',
          'lastname': 'Sobrenome',
          'username': 'Usuário',
          'email': 'Correio eletrônico',
          'password': 'Senha',
          'delegation': 'Delegação',
          'seller_type': 'Tipo de vendendor',
          'active': 'Ativo',
          'multi_type': 'Multimarca',
          'active_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'permissions': 'Permissões',
          'permissions_options': {
            'sellers': 'Vendedores',
            'clients': 'Clientes',
            'clients_records': 'Ficha Cliente',
            'contracts': 'Contratos',
            'messages': 'Mensagens',
            'reports': 'Relatórios',
            'master_data': 'São dados mestres?'
          }
        },
        'create_button': 'Criar vendedor',
        'create_success': 'Vendedor criado com sucesso',
        'sellers_update': 'Editar vendedor',
        'update_button': 'Editar vendedor',
        'update_success': 'Vendedor com êxito editado',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esse vendedor?'
        },
        'delete_success': 'Vendedor removido com sucesso'
      },
      'delegations': {
        'sellers_delegations': 'Lista de delegações',
        'create_delegation': 'Criar delegação',
        'see_filters': 'Veja filtros',
        'filters': {
          'name': 'Nome',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'name': 'Nome'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'menu_more_options': {
          'edit_delegation': 'Editar delegação',
          'delete_delegation': 'Eliminar delegação'
        },
        'sellers_delegations_create': 'Criar delegação',
        'fields': {
          'name': 'nome'
        },
        'create_button': 'Criar delegação',
        'create_success': 'Delegação criada com sucesso',
        'sellers_delegations_update': 'Editar delegação',
        'update_button': 'Editar delegação',
        'update_success': 'Delegação editada com sucesso',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esta delegação?'
        },
        'delete_success': 'Delegação foi excluída com êxito'
      },
      'sellers_types': {
        'sellers_types': 'Lista de tipos de vendedores',
        'create_seller_type': 'Criar tipo',
        'see_filters': 'Veja filtros',
        'filters': {
          'name': 'Nome',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'name': 'Nome'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'menu_more_options': {
          'edit_seller_type': 'Editar tipo',
          'delete_seller_type': 'Excluir tipo'
        },
        'sellers_types_create': 'Criar tipo',
        'fields': {
          'name': 'nome'
        },
        'create_button': 'Criar tipo',
        'create_success': 'Tipo de vendedor criado com sucesso',
        'sellers_types_update': 'Editar tipo',
        'update_button': 'Editar tipo',
        'update_success': 'Tipo de vendedor com êxito editado',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esse tipo de vendedor?'
        },
        'delete_success': 'Tipo de vendedor removido com sucesso'
      }
    },
    'clients': {
      'header': {
        'clients_list': 'Listagem'
      },
      'list': {
        'clients_list': 'Lista de clientes',
        'create_client': 'Criar cliente',
        'import_clients': 'Importar clientes',
        'export_clients': 'Exportar clientes',
        'migrate_clients': 'Migração de Importações',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'cif': 'NIF',
          'client_code': 'Código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'discharge_date': 'Data alta',
          'status': 'Estado',
          'recruiting_lr': 'Contratação LR',
          'mkt_news': 'Condições de correio',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'cif': 'NIF',
            'client_code': 'Código do cliente',
            'email': 'Correio eletrônico',
            'employees': 'Empregados',
            'lounge': 'Salão',
            'legal_name': 'Razão social',
            'discharge_date': 'Data alta',
            'status': 'Estado',
            'recruiting_lr': 'Contratação LR',
            'mkt_news': 'Condições de correio'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'associated_accounts': 'Contas associadas',
          'seller': 'Vendedor',
          'cfia': 'CFIA',
          'address': 'Endereço',
          'city': 'Cidadde',
          'province': 'Província',
          'postal_code': 'Código Postal',
          'cif': 'NIF',
          'client_code': 'Código do cliente',
          'delegation': 'Delegação',
          'email': 'Correio eletrônico',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'phone': 'telefono',
          'cellphone': 'telemovel',
          'web': 'web',
          'headquarters': 'Sede social',
          'owner_name': 'Nome propietario',
          'online_shop': 'Loja online',
          'resale_shop': 'Loja revenda',
          'have_salon': 'Tem salão',
          'have_salon_yes': 'Sim',
          'have_salon_no': 'Ñao',
          'nioxin_past_quantity': 'Nioxin quantidade passada',
          'sebastian_past_quantity': 'Sebastian quantidade passada',
          'sp_past_quantity': 'SP quantidade passada',
          'system_ec_past_quantity': 'System EC quantidade passada',
          'wella_past_quantity': 'Wella quantidade passada',
          'wella_real_past_quantity': 'Wella quantidade passada real',
          'total_contracted_past_quantity': 'Valor total contratado na última',
          'discharge_date': 'Data alta',
          'status': 'Estado',
          'status_active': 'Ativo',
          'status_inactive': 'Inativo',
          'recruiting_lr': 'Contratação LR',
          'recruiting_lr_yes': 'Sim',
          'recruiting_lr_no': 'Ñao',
          'mkt_news': 'Condições de correio',
          'mkt_news_yes': 'Sim',
          'mkt_news_no': 'Ñao',
          'image_conditions': 'Condições de imagem',
          'image_conditions_yes': 'Sim',
          'image_conditions_no': 'Ñao',
          'email_invoices': 'Faturas email',
          'email_invoices_yes': 'Sim',
          'email_invoices_no': 'Ñao'
        },
        'not_have_associated_accounts': 'Este cliente não possui contas associadas',
        'menu_more_options': {
          'associate_account': 'Conta associada',
          'see_associated_accounts': 'Listar contas associadas',
          'edit_client': 'Editar cliente',
          'delete_client': 'Remover cliente'
        },
        'associate_account_modal': {
          'title': 'Conta associada',
          'fields': {
            'client': 'procure um cliente',
            'legal_name': 'razão social',
            'cif': 'NIF',
            'email': 'Correio eletrônico'
          },
          'button': 'Conta associada',
          'success': 'Conta associada ao sucesso'
        },
        'associated_accounts_modal': {
          'title': 'Contas associadas',
          'menu_more_options': {
            'delete_association': 'Remover associação'
          },
          'question_modal': {
            'title': 'Aviso',
            'question': 'Tem certeza de que deseja excluir esta associação?'
          },
          'delete_success': 'Associação eliminada com sucesso'
        },
        'import_clients_modal': {
          'title': 'Importar clientes por CSV',
          'import_clients': 'Importar clientes',
          'fields': {
            'separator': 'Separador',
            'separator_options': {
              'coma': ',',
              'semicolon': ';',
              'pipe': '|'
            },
            'csv': 'Carregar documento CSV'
          },
          'please_wait': 'Aguarde um momento',
          'clients_to_update': 'Clientes para modificar',
          'clients_to_create': 'Clientes para adicionar',
          'clients_with_error': 'Clientes com erros',
          'no_clients_to_update': 'Não há clientes a serem modificados',
          'no_clients_to_create': 'Nenhum cliente para adicionar',
          'no_clients_with_error': 'Nenhum cliente com erros',
          'table': {
            'seller': 'Vendedor',
            'client_code': 'Código do cliente',
            'legal_name': 'Razão social',
            'cif': 'NIF',
            'observation': 'Observação'
          },
          'no_data_to_import': 'Você deve escolher pelo menos um cliente para modificar ou adicionar',
          'import_success': 'Clientes importados com sucesso'
        },
        'clients_list_create': 'Criar cliente',
        'fields': {
          'client': 'buscar cliente',
          'seller': 'vendedor',
          'cfia': 'CFIA',
          'cif': 'NIF',
          'client_code': 'código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'número de empregados',
          'lounges_quantity': 'número de saloes',
          'legal_name': 'razão social',
          'phone': 'telefono',
          'cellphone': 'telemovel',
          'address': 'endereço',
          'city': 'cidadde',
          'province': 'província',
          'postal_code': 'código Postal',
          'web': 'web',
          'headquarters': 'Sede social',
          'owner_name': 'Nome propietario',
          'online_shop': 'Loja online',
          'online_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'resale_shop': 'Loja revenda',
          'resale_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'have_salon_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'have_salon': 'Tem salão',
          'have_salon_yes': 'Sim',
          'have_salon_no': 'Ñao',
          'nioxin_past_quantity': 'Nioxin quantidade passada',
          'sebastian_past_quantity': 'Sebastian quantidade passada',
          'sp_past_quantity': 'SP quantidade passada',
          'system_ec_past_quantity': 'System EC quantidade passada',
          'wella_past_quantity': 'Wella quantidade passada',
          'wella_real_past_quantity': 'Wella quantidade passada real',
          'total_contracted_past_quantity': 'Valor total contratado na última',
          'discharge_date': 'data alta',
          'status': 'estado',
          'status_options': {
            'active': 'Ativo',
            'inactive': 'Inativo'
          },
          'recruiting_lr': 'recrutamento LR',
          'recruiting_lr_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'conditions': 'Condições',
          'conditions_options': {
            'image_conditions': 'Dou o meu consentimento para que a sociedade possa capturar a minha imagem'
          },
          'email_invoices': 'Cliente deseja receber faturas via e-mail?',
          'email_invoices_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'create_button': 'Criar cliente',
        'create_success': 'Cliente criado com sucesso',
        'clients_update': 'Editar cliente',
        'update_button': 'Editar cliente',
        'update_success': 'Cliente editado com sucesso',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esse cliente?'
        },
        'delete_success': 'Cliente excluído com sucesso'
      }
    },
    'clients_records': {
      'header': {
        'clients_records_list': 'Listagem'
      },
      'list': {
        'clients_list': 'Lista de guias do cliente',
        'export_clients_records': 'Exportar arquivo do cliente',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'cif': 'NIF',
          'client_code': 'Código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'discharge_date': 'Data alta',
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente'
          },
          'updated': 'Atualizado',
          'updated_options': {
            'yes': 'Sim',
            'not': 'Ñao'
          },
          'recruiting_lr': 'Contratação LR',
          'mkt_news': 'Condições de correio',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'pdf': 'Veja PDF',
          'sort_options': {
            'created_at': 'Data de criação',
            'cif': 'NIF',
            'client_code': 'Código do cliente',
            'email': 'Correio eletrônico',
            'employees': 'Empregados',
            'lounge': 'Salão',
            'legal_name': 'Razão social',
            'discharge_date': 'Data alta',
            'status': 'Estado',
            'recruiting_lr': 'Contratação LR',
            'mkt_news': 'Condições de correio'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'client_code': 'Código do cliente',
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente'
          },
          'sales_area': 'Area venda',
          'activity': 'Atividade',
          'update_client': 'Atualizar cliente',
          'update_client_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'cfia': 'CFIA',
          'associate_account_1': 'Conta associada 1',
          'associate_account_2': 'Conta associada 2',
          'associate_account_3': 'Conta associada 3',
          'date': 'Data',
          'closing_days': 'Dia encerramento',
          'email': 'Correio eletrônico',
          'email_invoices': 'Faturas email',
          'mkt_news_2': 'Dados Pessoais',
          'dados_pessoais': 'Imagen',
          'email_invoices_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'delivery_time': 'Horario entrega',
          'resale_shop': 'Loja revenda',
          'resale_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'online_shop': 'Loja online',
          'online_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'particular_address': 'Morada particular',
          'particular_address_cp': 'Morada particular CP',
          'particular_address_location': 'Morada particular localidade',
          'address_1': 'Morada 1',
          'address_1_cp': 'Morada 1 CP',
          'address_1_localidade': 'Morada 1 localidade',
          'address_2': 'Morada 2',
          'address_2_cp': 'Morada 2 CP',
          'address_2_localidade': 'Morada 2 localidade',
          'address_observations': 'Morada observaciones',
          'nif': 'NIF',
          'nioxin_support': 'Nioxin apoio',
          'mkt_news': 'Condições de correio',
          'mkt_news_yes': 'Sim',
          'mkt_news_no': 'Ñao',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'sebastian_support': 'Sebastian apoio',
          'headquarters': 'Sede social',
          'headquarters_cp': 'Sede social CP',
          'headquarters_location': 'Sede social localidade',
          'sp_support': 'SP apoio',
          'phone': 'Telefono',
          'cellphone': 'Telemovel',
          'client_type': 'Tipo cliente',
          'wella_support': 'Wella apoio',
          'owner_name': 'Nome propietario',
          'industry_code': ' Industry Code Details ',
          'customer_class': 'CUSTOMER CLASS ',
          'email_invoices_1': 'Email fatura 1',
          'email_invoices_2': 'Email fatura 2',
          'my_creation_date': 'Fecha creacion',
          'pdf': 'Veja PDF'
        },
        'not_have_associated_accounts': 'Este cliente não possui contas associadas',
        'menu_more_options': {
          'approve': 'aprova',
          'disapprove': 'desaprovar'
        },
        'associate_account_modal': {
          'title': 'Conta associada',
          'fields': {
            'client': 'procure um cliente',
            'legal_name': 'razão social',
            'cif': 'NIF',
            'email': 'Correio eletrônico'
          },
          'button': 'Conta associada',
          'success': 'Conta associada ao sucesso'
        },
        'associated_accounts_modal': {
          'title': 'Contas associadas',
          'menu_more_options': {
            'delete_association': 'Remover associação'
          },
          'question_modal': {
            'title': 'Aviso',
            'question': 'Tem certeza de que deseja excluir esta associação?'
          },
          'delete_success': 'Associação eliminada com sucesso'
        },
        'import_clients_modal': {
          'title': 'Importar clientes por CSV',
          'import_clients': 'Importar clientes',
          'fields': {
            'separator': 'Separador',
            'separator_options': {
              'coma': ',',
              'semicolon': ';',
              'pipe': '|'
            },
            'csv': 'Carregar documento CSV'
          },
          'please_wait': 'Aguarde um momento',
          'clients_to_update': 'Clientes para modificar',
          'clients_to_create': 'Clientes para adicionar',
          'clients_with_error': 'Clientes com erros',
          'no_clients_to_update': 'Não há clientes a serem modificados',
          'no_clients_to_create': 'Nenhum cliente para adicionar',
          'no_clients_with_error': 'Nenhum cliente com erros',
          'table': {
            'seller': 'Vendedor',
            'client_code': 'Código do cliente',
            'legal_name': 'Razão social',
            'cif': 'NIF',
            'observation': 'Observação'
          },
          'no_data_to_import': 'Você deve escolher pelo menos um cliente para modificar ou adicionar',
          'import_success': 'Clientes importados com sucesso'
        },
        'clients_list_create': 'Criar cliente',
        'fields': {
          'client': 'buscar cliente',
          'seller': 'vendedor',
          'cfia': 'CFIA',
          'cif': 'NIF',
          'client_code': 'código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'número de empregados',
          'lounges_quantity': 'número de saloes',
          'legal_name': 'razão social',
          'receive_communications': 'Receber Comunicações',
          'receive_communications_options': {
            'receive_communications': 'Receber Comunicações'
          },
          'discharge_date': 'data alta',
          'status': 'estado',
          'status_options': {
            'active': 'Ativo',
            'inactive': 'Inativo'
          },
          'recruiting_lr': 'recrutamento LR',
          'recruiting_lr_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'conditions': 'Condições',
          'conditions_options': {
            'image_conditions': 'Dou o meu consentimento para que a sociedade possa capturar a minha imagem'
          }
        },
        'create_button': 'Criar cliente',
        'create_success': 'Cliente criado com sucesso',
        'approve_client_record_success': 'Arquivo de cliente bem sucedido',
        'update_button': 'Editar cliente',
        'update_success': 'Cliente editado com sucesso',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja desaprovar este arquivo de cliente?'
        },
        'disapprove_success': 'arquivo de cliente reprovado com sucesso',
        'approve_client_record_window': {
          'title': 'Aprova o arquivo do cliente',
          'search_button': 'aprova'
        }
      }
    },
    'contracts': {
      'header': {
        'contracts_list': 'Contratos',
        'contracts_sda': 'SDA',
        'contracts_history': 'Histórico',
        'contracts_zips': 'Zips'
      },
      'list': {
        'contracts_list': 'Lista de contratos',
        'create_contract': 'Criar um contrato',
        'export_contracts': 'Contratos de exportação',
        'export_zip_pdfs': 'Exportar PDFs Zip',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Status',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'since': 'De',
          'until': 'Para cima',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social'
        },
        'no_results': 'nenhum resultado encontrado',
        'forward_email': 'Reenviar Email',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'observations': 'Observações',
          'timestamp': 'Timestamp',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'employees_quantity': 'Funcionários',
          'email': 'Correio eletrônico',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'pdf': 'Veja PDF',
          'salons': 'SALÕES',
          'premium': 'PREMIUM',
          'premium_agreement': 'Premium Acordo',
          'premium_ATS': 'Premium ATS',
          'premium_PTS': 'Premium PTS',
          'premium_Brands': 'Premium Marcas',
          'premium_MTKG': 'Premium Pacote de Apoio',
          'premium_rappel_1': 'Premium % RAPPEL',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_variable_discount_1': 'Premium Dto Variável',
          'premium_variable_discount_2': 'Premium Dto Variável 2',
          'premium_salon': 'Premium Tipo de Cliente',
          'premium_education': 'Premium Educação',
          'premium_potential': 'Premium Potencial',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_date': 'Fecha',
          'premium_salon_value': 'Valor do salão',
          'premium_MTKG_Subtype': 'Premium Pacote de Apoio Seleção',
          'premium_section_1': 'Premium Section',
          'premium_section_2': 'Premium Section 2',
          'premium_discount_1': 'PremiumDesconto',
          'premium_discount_2': 'PremiumDesconto 2',
          'premium_event': 'Premium Evento',
          'prestige': 'PRESTIGE',
          'prestige_agreement': 'Prestige ACUERDO',
          'prestige_ATS': 'Prestige ATS',
          'prestige_PTS': 'Prestige PTS',
          'prestige_Brands': 'Prestige MARCAS',
          'prestige_MTKG': 'Prestige Pacote de Apoio',
          'prestige_salon': 'Prestige Tipo de Cliente',
          'prestige_education': 'Prestige Educação',
          'prestige_potential': 'Prestige Potencial',
          'prestige_rappel_1': 'Prestige % RAPPEL',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'Prestige RAPPEL Freqüência',
          'prestige_variable_discount_1': 'Prestige Dto Variável 1',
          'prestige_variable_discount_2': 'Prestige Dto Variável 2',
          'prestige_discount_total': 'Prestige DTO (TOTAL)',
          'prestige_date': 'Data',
          'prestige_salon_value': 'Valor do salão',
          'prestige_MTKG_Subtype': 'Prestige Pacote de Apoio Seleção',
          'prestige_section_1': 'Prestige Section',
          'prestige_section_2': 'Prestige Section 2',
          'prestige_discount_1': 'PrestigeDesconto 1',
          'prestige_discount_2': 'PrestigeDesconto 2',
          'prestige_event': 'Prestige Evento',
          'dso': 'DSO',
          'dso_agreement': 'WELLA FY27',
          'dso_PTS': 'Prestige PTS',
          'dso_Brands': 'MARCAS',
          'dso_MTKG': 'Pacote de Apoio',
          'dso_salon': 'Tipo de Cliente',
          'dso_education': 'EDUCAÇÃO',
          'dso_potential': 'POTENCIAL',
          'dso_rappel': '% Rappel Wella, Nioxin, Sebastian, SP, wedo y Briogeo',
          'briogeo_rappel': '% Rappel Briogeo',
          'dso_rappel_marketing': '% RAPPEL MARKETING',
          'dso_rappel_frequency': 'RAPPEL FREQÜÊNCIA',
          'dso_discount': 'DTO (TOTAL)',
          'dso_date': 'Data',
          'dso_salon_value': 'Valor do salão',
          'dso_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'dso_section': 'Section',
          'has_prestige_condition_FY2223': 'Condições especiais Prestige',
          'iso': 'ISO',
          'wella': 'WELLA',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'wella_quantity': 'WELLA & NIOXIN & OPI QUANTIDADE',
          'wella_support': 'Wella apoio',
          'wella_discount': 'WELLA & NIOXIN & OPI Desconto',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_euros': '€ Sassoon',
          'rappel_antecipado': 'Rappel antecipado',
          'sebastian_man_rappel': 'Sebastian Man rappel',
          'sebastian_man_discount': 'Sebastian Man desconto',
          'nioxin_quantity': 'Nioxin quantidade',
          'nioxin_support': 'Nioxin apoio',
          'sp_quantity': 'SP quantidade',
          'sp_support': 'SP apoio',
          'system_ec_quantity': 'System EC quantidade',
          'system_ec_support': 'System EC apoio',
          'sebastian_quantity': 'Sebastian quantidade',
          'sebastian_support': 'Sebastian apoio',
          'sebastian_brand_rappel': 'Sebastian rappel acordo',
          'sebastian_growth_rappel': 'Sebastian rappel crescimento',
          'sebastian_total_rappel': 'Sebastian rappel total',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'system_ec_potential': 'Potencial System EC',
          'sebastian_potential': 'Potencial Sebastian',
          'seb_man_rappel': 'Rappel Sebman/Nioxin',
          'seb_man_discount': 'Desconto Sebman/Nioxin',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_rappel': 'Rappel Opi',
          'changeds': 'MODIFICAÇÕES',
          'changed_quantity': 'Montante',
          'changed_franchise': 'Franquia',
          'changed_rappel_period': 'Freq Rappel',
          'changed_associates': 'Associados',
          'changed_MTKG': 'MKTG',
          'digital_signature': 'Consentimiento',
          'virtual_signed': 'Digital',
          'virtual_signApproved': 'Aprovado',
          'mail_auto_renew': 'Auto-renovável',
          'mail_new_package': 'Novo pacote',
          'dados_pessoais': 'Dados Pessoais',
          'dto_zto_wellastore': 'DTO ZTO wellastore',
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated': 'Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses prorrateados',
          'has_email_invoices': '¿desea fra electrónica?',
          'email_invoices_1': 'mail fra electrónica 1',
          'email_invoices_2': 'mail fra electrónica 2'
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Contrato de arquivo'
        },
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja arquivar este contrato?'
        },
        'contracts_list_create': 'Criar um contrato',
        'client_not_have_relations': 'Este cliente não possui associações',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial e descontos',
        'observations': 'Observações',
        'block_premium': 'PREMIUM',
        'block_prestige': 'PRESTIGE',
        'block_wella': 'WELLA',
        'block_opi': 'OPI',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'contract_mode': 'Modo de contrato',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'app_creation_cate': 'Data',
          'associate_accounts': 'Conta associada',
          'brands': 'MARCAS',
          'prestige': 'PRESTIGE',
          'prestige_date': 'Data',
          'prestige_Brands': 'Adicionar marcas',
          'prestige_Brands_view': 'Marcas',
          'prestige_MTKG_Subtype_Brands': 'Seleção do pacote de suporte, até duas opções',
          'prestige_ATS': 'ATS',
          'prestige_PTS': 'PTS',
          'prestige_event': 'Prestige Event',
          'prestige_MTKG': 'Pacote de suporte',
          'prestige_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'prestige_salon': 'Digite Cliente',
          'prestige_salon_options': {
            'grand_salon': 'Grand Salon',
            'imagen': 'Imagen',
            'partner': 'Partner'
          },
          'prestige_salon_value': 'Valor do salão',
          'prestige_education': 'Educação',
          'prestige_potential': 'Potencial',
          'prestige_rappel_frequency': 'Rappel Freqüência',
          'prestige_section_1': 'Seção',
          'prestige_section_2': 'Seção 2',
          'prestige_section_3': 'Seção 3',
          'prestige_rappel_1': 'Rappel',
          'prestige_rappel_2': 'Rappel 2',
          'prestige_rappel_3': 'Rappel 3',
          'prestige_rappel_marketing_1': 'Rappel Marketing',
          'prestige_rappel_marketing_2': 'Rappel Marketing 2',
          'prestige_rappel_marketing_3': 'Rappel Marketing 3',
          'prestige_discount_1': 'Desconto',
          'prestige_discount_2': 'Desconto 2',
          'prestige_discount_3': 'Desconto 3',
          'prestige_variable_discount_1': 'Desconto Variável',
          'prestige_variable_discount_2': 'Desconto Variável 2',
          'prestige_variable_discount_3': 'Desconto Variável 3',
          'premium': 'PREMIUM',
          'premium_date': 'Data',
          'premium_Brands': 'Adicionar marcas',
          'premium_Brands_view': 'Marcas',
          'premium_MTKG': 'Pacote de suporte',
          'premium_ATS_1': 'ATS',
          'premium_ATS_2': 'ATS 2',
          'premium_ATS_3': 'ATS 3',
          'premium_PTS_1': 'PTS',
          'premium_PTS_2': 'PTS 2',
          'premium_PTS_3': 'PTS 3',
          'premium_event': 'Premium Event',
          'premium_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'premium_section_1': 'Seção',
          'premium_section_2': 'Seção 2',
          'premium_rappel_1': 'Rappel',
          'premium_section_3': 'Seção 3',
          'premium_rappel_2': 'Rappel 2',
          'premium_rappel_3': 'Rappel 3',
          'premium_rappel_marketing_1': 'Rappel Marketing',
          'premium_rappel_marketing_2': 'Rappel Marketing 2',
          'premium_rappel_marketing_3': 'Rappel Marketing 3',
          'premium_discount_1': 'Desconto',
          'premium_discount_2': 'Desconto 2',
          'premium_discount_3': 'Desconto 3',
          'premium_variable_discount_1': 'Desconto Variável',
          'premium_variable_discount_2': 'Desconto Variável 2',
          'premium_variable_discount_3': 'Desconto Variável 3',
          'premium_education_1': 'Educação',
          'premium_education_2': 'Educação 2',
          'premium_education_3': 'Educação 3',
          'premium_salon': 'Digite Cliente',
          'premium_salon_options': {
            'wella_create': 'Wella Create',
            'wella_artist': 'Wella Artist',
            'wella_business': 'Wella Business Club',
            'wella_vip': 'Wella Vip'
          },
          'premium_salon_value': 'Valor do salão',
          'premium_potential': 'Potential',
          'premium_rappel_frequency': 'Rappel Freqüência',
          'dso': 'DSO',
          'dso_date': 'Data',
          'dso_drands_view': 'Marcas',
          'dso_MTKG_Subtype_Brands': 'Seleção do pacote de suporte, até duas opções',
          'dso_PTS': 'PTS',
          'dso_MTKG': 'Pacote de suporte',
          'dso_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'dso_salon': 'Digite Cliente',
          'dso_salon_options': {
            'grand_salon': 'Grand Salon',
            'imagen': 'Imagen',
            'partner': 'Partner'
          },
          'dso_salon_value': 'Valor do salão',
          'dso_education': 'Educação',
          'dso_potential': 'Potencial',
          'dso_rappel_frequency': 'Rappel Freqüência',
          'dso_section': 'Seção',
          'dso_rappel': 'Rappel',
          'briogeo_rappel': 'Rappel Briogeo',
          'dso_rappel_marketing': 'Rappel Marketing',
          'dso_discount': 'Desconto',
          'has_prestige_condition_FY2223': 'O Prestige FY2223 tem condições especiais?',
          'BRAND_WELLA': 'Wella',
          'BRAND_SP': 'SP',
          'BRAND_NIOXIN': 'Nioxin',
          'BRAND_SP_DIAMOND': 'SSP',
          'BRAND_SASSOON': 'Sassoon',
          'BRAND_SEBASTIAN': 'Sebastian',
          'iso': 'ISO',
          'wella': 'WELLA',
          'wella_quantity': 'Quantidade',
          'wella_discount': 'Wella DTO Wella/OPI/Nioxim',
          'wella_volume_rappel': 'Rapel Wella/OPI/Nioxim',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'seb_man_rappel': 'Rappel Nioxin/OPIOPI',
          'seb_man_discount': 'Desconto Nioxin/OPI',
          'observations': 'Observações',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'pdf': 'Adicionar arquivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          },
          'salon_options': {
            'grand_salon': 'Grand Salon',
            'imagen': 'Imagen',
            'partner': 'Partner'
          },
          'premium_MTKG_options': {
            'wella_app': 'Wella APP',
            'congreso': '€ Congreso',
            'evento_app': 'Evento Wella + Wella APP',
            'evento_congreso': 'Evento Wella + € Congreso',
            'rappel_mkt': 'Rappel MKT',
            'evento_rappel_mkt': 'Evento Wella + Rappel MKT'
          },
          'prestige_MTKG_options': {
            'wella_app': 'Wella APP',
            'congreso': '€ Congreso',
            'evento_sebastian': 'Evento Sebastian + Wella APP',
            'evento_sebastian_congreso': 'Evento Sebastian + € Congreso',
            'rappel_mkt': 'Rappel MKT',
            'evento_rappel_mkt': 'Evento Sebastian + Rappel MKT'
          },
          'MTKG_options': {
            'congreso_eventos': '€ Congresso / Eventos',
            'rappel_marketing': 'Rappel Marketing',
            'prestige_app': 'PRESTIGE APP',
            'wella_app': 'WELLA APP'
          },
          'MTKG_Subtype_digital_options': {
            'koibox': 'Koibox',
            'google_adwords': 'Google Adwords',
            'treatwell': 'Treatwell (Disponible solo en MAD/BCN)'
          },
          'prorated': 'Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses rateados',
          'opi': 'OPI',
          'opi_rappel': 'OPI rappel',
          'opi_quantity': 'quantidade OPI',
          'opi_discount': 'desconto OPI',
          'add_Brands': 'Adicionar marcas',
          'view_brands': 'Marcas'
        },
        'create_button': 'Criar um contrato',
        'create_success': 'Contrato criado com sucesso',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado com sucesso',
        'archive_success': 'Contrato arquivado com sucesso',
        'send_mail_success': 'O email foi enviado com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Posso',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Año'
          },
          'download_button': 'descargar zip'
        }
      },
      'sda': {
        'sda_list': 'Contratos SDA',
        'create_contract_sda': 'Criar contrato SDA',
        'export_zip_pdfs': 'Exportar Zip PDFs',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Não exportado'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'sda_sp': 'SDA System Professional',
          'sda_sp_options': {
            'ok': 'ok'
          },
          'sda_sp_internet': 'SDA SP Internet',
          'sda_sp_internet_options': {
            'ok': 'ok'
          },
          'sda_sp_men': 'SDA SP Men',
          'sda_sp_men_options': {
            'ok': 'ok'
          },
          'sda_system_ec': 'SDA System EC',
          'sda_system_ec_options': {
            'ok': 'ok'
          },
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_options': {
            'ok': 'ok'
          },
          'sda_sebastian_internet': 'SDA Sebastian Internet',
          'sda_sebastian_internet_options': {
            'ok': 'ok'
          },
          'sda_ghd': 'SDA GHD',
          'sda_ghd_options': {
            'ok': 'ok'
          },
          'sda_wedo': 'SDA Wedo',
          'sda_wedo_options': {
            'ok': 'ok'
          },
          'sp_date': 'SP Data',
          'sp_internet_date': 'SP Internet Data',
          'sp_men_date': 'SP Men Data',
          'sp_system_ec_date': 'System EC Data',
          'sebastian_date': 'Sebastian Data',
          'sebastian_internet_date': 'Sebastian Internet Data',
          'sda_ghd_date': 'SDA GHD Data',
          'sda_wedo_date': 'SDA Wedo Data',
          'sda_date': 'SDA Data Ult',
          'normal_sda_pdf': 'SDA PDF',
          'system_ec_sda_pdf': 'SDA System EC PDF',
          'sebastian_sda_pdf': 'SDA Sebastian PDF',
          'sda_wedo_pdf': 'Ver PDF SDA Wedo',
          'sda_link_pdf': 'Ver PDF',
          'normal_sda_virtual_signed': 'SDA Consentimiento digital',
          'system_ec_sda_virtual_signed': 'SDA System EC Consentimiento digital',
          'wedo_sda_virtual_signed': 'SDA Wedo Consentimiento digital',
          'sebastian_sda_virtual_signed': 'SDA Sebastian Consentimiento digital',
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Contrato de arquivo'
        },
        'create_contract_window': {
          'title': 'Criar contrato SDA',
          'fields': {
            'client': 'Cliente',
            'sda_types': 'Tipos de SDA',
            'sda_types_options': {
              'sda_sp': 'SDA SP',
              'sda_sp_internet': 'SDA SP Internet',
              'sda_sp_men': 'SDA SP Men',
              'sda_system_ec': 'SDA System EC',
              'sda_sebastian': 'SDA Sebastian',
              'sda_sebastian_internet': 'SDA Sebastian Internet',
              'sda_ghd': 'SDA GHD',
              'sda_wedo': 'SDA Wedo'
            },
            'date': 'Data',
            'pdf': 'Adicionar arquivo PDF',
            'pdf_sp_diamond': 'Adicionar arquivo PDF Sp Diamond'
          },
          'create_button': 'Criar contrato SDA',
          'create_success': 'Contrato SDA criado com sucesso'
        },
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado com sucesso',
        'archive_success': 'Contrato arquivado com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Posso',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Año'
          },
          'download_button': 'baixar zip'
        }
      },
      'history': {
        'contracts_history': 'Histórico',
        'create_histrory': 'Criar histórico',
        'export_contracts': 'Contratos de exportação',
        'export_zip_pdfs': 'Exportar PDFs Zip',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'selectYears': 'Ano',
        'filters': {
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Status',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'since': 'De',
          'until': 'Para cima',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social'
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'timestamp': 'Timestamp',
          'seller': 'VENDEDORES',
          'client': 'CLIENTES',
          'associated': 'ASSOCIADOS',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'associated_code': 'Código',
          'associated_cif': 'NIF',
          'associated_email': 'Correio eletrônico',
          'associated_legal_name': 'Razão social',
          'associated_employees': 'Empregados',
          'observations': 'Observações',
          'prorated': '¿Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses rateados',
          'manual_date': 'Data Manual',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'pdf': 'Veja PDF',
          'salons': 'SALÕES',
          'premium': 'PREMIUM',
          'premium_agreement': 'Premium Acordo',
          'premium_ATS': 'Premium ATS',
          'premium_Brands': 'Premium Marcas',
          'premium_MTKG': 'Premium Pacote de Apoio',
          'premium_rappel_1': 'Premium % RAPPEL Escalada 1',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing 1',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_variable_discount_1': 'Premium Dto Variável 1',
          'premium_variable_discount_2': 'Premium Dto Variável 2',
          'premium_salon': 'Premium Tipo de Cliente',
          'premium_education': 'Premium Educação',
          'premium_potential': 'Premium Potencial',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_date': 'Data',
          'premium_salon_value': 'Valor do salão',
          'premium_MTKG_Subtype': 'Premium Pacote de Apoio Seleção',
          'premium_section_1': 'Premium Section 2',
          'premium_section_2': 'Premium Section 2',
          'premium_discount_1': 'PremiumDesconto 1',
          'premium_discount_2': 'PremiumDesconto 2',
          'prestige': 'PRESTIGE',
          'prestige_agreement': 'Prestige ACUERDO',
          'prestige_ATS': 'Prestige ATS',
          'prestige_Brands': 'Prestige MARCAS',
          'prestige_MTKG': 'Prestige Pacote de Apoio',
          'prestige_salon': 'Prestige Tipo de Cliente',
          'prestige_education': 'Prestige Educação',
          'prestige_potential': 'Prestige Potencial',
          'prestige_rappel_1': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing 1',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'Prestige RAPPEL Freqüência',
          'prestige_variable_discount_1': 'Prestige Dto Variável 1',
          'prestige_variable_discount_2': 'Prestige Dto Variável 2',
          'prestige_discount_total': 'Prestige DTO (TOTAL)',
          'prestige_date': 'Data',
          'prestige_salon_value': 'Valor do salão',
          'prestige_MTKG_Subtype': 'Prestige Pacote de Apoio Seleção',
          'prestige_section_1': 'Prestige Section 2',
          'prestige_section_2': 'Prestige Section 2',
          'prestige_discount_1': 'PrestigeDesconto 1',
          'prestige_discount_2': 'PrestigeDesconto 2',
          'iso': 'ISO',
          'wella': 'WELLA',
          'wella_quantity': 'Wella quantidade',
          'wella_support': 'Wella apoio',
          'wella_discount': 'Desconto',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'rappel_antecipado': 'Rappel antecipado',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'nioxin_quantity': 'Nioxin quantidade',
          'nioxin_support': 'Nioxin apoio',
          'sp_quantity': 'SP quantidade',
          'sp_support': 'SP apoio',
          'system_ec_quantity': 'System EC quantidade',
          'system_ec_support': 'System EC apoio',
          'sebastian_quantity': 'Sebastian quantidade',
          'sebastian_support': 'Sebastian apoio',
          'sebastian_brand_rappel': 'Sebastian rappel acordo',
          'sebastian_growth_rappel': 'Sebastian rappel crescimento',
          'sebastian_total_rappel': 'Sebastian rappel total',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'system_ec_potential': 'Potencial System EC',
          'sebastian_potential': 'Potencial Sebastian',
          'seb_man_rappel': 'Rappel Nioxin/Sebman',
          'seb_man_discount': 'Desconto Nioxin/Sebman',
          'wella_date': 'Data',
          'wella_salon': 'Salão',
          'wella_rappel': 'Rappel',
          'wella_variable_discount': 'DTO Variable',
          'wella_trade': 'Trade',
          'sp': 'SYSTEM',
          'sp_date': 'Data',
          'sp_salon': 'Salon',
          'sp_discount': 'DTO',
          'sp_rappel': 'Rappel',
          'sp_variable_discount': 'DTO Variable',
          'sebastian': 'SEBASTIAN',
          'sebastian_date': 'Data',
          'sebastian_salon': 'Salon',
          'sebastian_discount': 'DTO',
          'sebastian_rappel': 'Rappel',
          'sassoon': 'SASSON',
          'sassoon_date': 'Data',
          'sassoon_quantity': 'Professional',
          'sassoon_salon': 'Salon',
          'sassoon_discount': 'DTO',
          'sassoon_rappel': 'Rappel',
          'sassoon_potential': 'Potencial',
          'sp_diamond': 'SP DIAMOND',
          'sp_diamond_date': 'Data',
          'sp_diamond_quantity': 'Professional',
          'sp_diamond_salon': 'Salon',
          'sp_diamond_discount': 'DTO',
          'sp_diamond_rappel': 'Rappel',
          'sp_diamond_potential': 'Potencial',
          'nioxin': 'NIOXIN',
          'nioxin_date': 'Data',
          'nioxin_salon': 'Salon',
          'nioxin_discount': 'DTO',
          'nioxin_summer_discount': 'DTO Verano',
          'nioxin_rappel': 'Rappel',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_discount': 'DTO',
          'opi_rappel': 'Rappel Opi',
          'opi_potential': 'Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'comments': 'Comentarios',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mail_conditions': 'Condições de correio',
          'mail_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'image_conditions': 'Condiciones imagen',
          'image_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea archivar este contrato?'
        },
        'contracts_history_create': 'Crear historial',
        'client_not_have_relations': 'Este cliente não possui associações',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial y descuentos',
        'observations': 'Observaciones',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'associate_accounts': 'Asociar cuentas',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses prorrateados',
          'manual_date': 'Data Manual',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'pdf': 'Agregar archivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          },
          'wella_date': 'Wella Data',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Wella Descuento',
          'wella_rappel': 'Wella Rappel',
          'wella_potential': 'Wella Potencial',
          'wella_variable_discount': 'Wella Descuento Variable',
          'wella_trade': 'Wella Trade',
          'sp_date': 'System Data',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'System Descuento',
          'sp_rappel': 'System Rappel',
          'sp_potential': 'System Potencial',
          'sp_variable_discount': 'System Descuento Variable',
          'sp_diamond_date': 'SP Diamond Data',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Diamond Descuento',
          'sp_diamond_rappel': 'Diamond Rappel',
          'sp_diamond_potential': 'Diamond Potencial',
          'sebastian_date': 'Sebastian Data',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Sebastian Descuento',
          'sebastian_rappel': 'Sebastian Rappel',
          'sebastian_potential': 'Sebastian Potencial',
          'sassoon_date': 'Sassoon Data',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Sassoon Descuento',
          'sassoon_rappel': 'Sassoon Rappel',
          'sassoon_potential': 'Sassoon Potencial',
          'nioxin_date': 'Nioxin fecha',
          'nioxin_quantity': 'Nioxin Professional',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_discount': 'NioxinDescuento',
          'nioxin_summer_discount': 'Nioxin Desc. Verano',
          'nioxin_rappel': 'Nioxin Rappel',
          'nioxin_potential': 'Nioxin Potencial',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Opi Descuento',
          'opi_rappel': 'Opi Rappel',
          'opi_potential': 'Opi Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'create_button': 'Crear contrato',
        'create_success': 'Contrato creado con éxito',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito',
        'export_zip_pdfs_window': {
          'title': 'Descargar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'download_button': 'descargar zip'
        },
        'create_history_window': {
          'title': 'Crear Historial',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'start_button': 'Generar Histrorial'
        },
        'message': {
          'status': {
            'finalized': 'Proceso finalizado con exito'
          }
        }
      },
      'zips': {
        'contract_list': 'Lista de arquivos Zips',
        'export_zip_pdfs': 'Gerar Zip',
        'please_wait': 'Por favor, aguarde um momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'seller_type': 'Tipo de Contracto',
          'seller_type_options': {
            'Tipo': 'Tipo de Contracto',
            'DSO': 'DSO',
            'ISO': 'ISO',
            'OPI': 'OPI'
          },
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'since': 'Desde',
          'until': 'Hasta',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'client_code': 'ID cliente',
          'client_cif': 'NIF',
          'legal_name': 'Razón social'
        },
        'no_results': 'Nenhum resultado encontrado',
        'forward_email': 'Encaminhar e-mail',
        'limit_zips': 'Você atingiu o limite máximo de Zips permitidos.',
        'table': {
          'date': 'Data',
          'zipPDF': 'ZipPDF',
          'since': 'Desde',
          'until': 'Até',
          'state': 'State',
          'sizeFile': 'tamanho Zip',
          'totalPDFs': 'Total de PDFs',
          'expire': 'Data de Expiração',
          'actions': 'Ações',
          'year': 'Ano',
          'month': 'Mês'
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Livrar-se de',
          'question': 'Tem certeza de que deseja excluir este zip?'
        },
        'create_success': 'Zip gerado com sucesso',
        'delete_success': 'Zip excluído com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mês',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Maio',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Ano'
          },
          'download_button': 'baixar zip'
        }
      }
    },
    'reports': {
      'header': {
        'master_data': 'Master Data',
        'sda': 'SDA',
        'potential': 'Potencial',
        'cci': 'CCI',
        'education': 'Educação'
      },
      'master_data': {
        'master_data_list': 'Relatório Master Data',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'export': {
          'no_data': 'Você deve selecionar pelo menos um contrato'
        },
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'groupings': {
          'name': 'Agrupar por:',
          'codeClient': 'Código do cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor'
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'pages': 'Páginas',
          'pages_options': {
            'all': 'Todas Pág.',
            'current': 'Pag. atual'
          },
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'associated_accounts': 'Contas associadas',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'contractMode': 'Ano fiscal',
          'premium_agreement': 'Premium Acordo',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_rappel_1': 'Premium % RAPPEL',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_3': 'Premium % RAPPEL Escalada 3',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_cto_to': 'PREMIUM CTO VÁLIDO DE',
          'premium_cto_from': 'PREMIUM CTO VÁLIDO ATÉ',
          'prestige_agreement': 'ACUERDO',
          'prestige_discount_total': 'DTOS (TOTAL) wella&Nioxin&Sebastian&WeDO&SP',
          'prestige_rappel_1': '% RAPPEL',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 2',
          'prestige_rappel_3': 'Prestige % RAPPEL Escalada 3',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'RAPPEL Freqüência',
          'prestige_cto_to': 'CTO VÁLIDO DE',
          'prestige_cto_from': 'CTO VÁLIDO ATÉ',
          'dso': 'DSO',
          'dso_agreement': 'WELLA FY27',
          'dso_discount_total': 'DTOS (TOTAL)wella&Nioxin&Sebastian&WeDO&Sassoon&SP, Briogeo',
          'dso_rappel': '% Rappel Wella, Nioxin, Sebastian, SP, wedo, Sassoon y Briogeo',
          'briogeo_rappel': '% Rappel Briogeo',
          'dso_rappel_marketing': '% RAPPEL MARKETING',
          'dso_rappel_frequency': 'RAPPEL FREQÜÊNCIA',
          'dso_cto_to': 'CTO VÁLIDO DE',
          'dso_cto_from': 'CTO VÁLIDO ATÉ',
          'iso': 'ISO',
          'iso_cto_to': 'ISO CTO VÁLIDO DE',
          'iso_cto_from': 'ISO CTO VÁLIDO ATÉ',
          'wella': 'WELLA',
          'wella_quantity': 'ISO wella + opi + nioxin',
          'wella_support': 'Wella apoio',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'wella_total_discount': 'Desconto total da Wella',
          'wella_discount': 'ISO DTO: WELLA&NIOXIN&OPI',
          'wella_rappel_frequency': 'ISO RAPPEL FREQÜÊNCIA',
          'rappel_antecipado': 'Rappel antecipado',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'seb_man_rappel': 'Rappel Nioxin/OPI',
          'seb_man_discount': 'Desconto Nioxin/OPI',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_rappel': 'Rappel Opi',
          'opi_cto_to': 'OPI CTO VÁLIDO DE',
          'opi_cto_from': 'OPI CTO VÁLIDO ATÉ',
          'opi_rappel_frequency': 'OPI RAPPEL FREQÜÊNCIA',
          'dto_zto_wellastore': 'DTO ZTO wellastore',
          'observations': 'Observações',
          'timestamp': 'Timestamp',
          'changed_quantity': 'Montante',
          'changed_franchise': 'Criar Franquia',
          'changed_rappel_period': 'Freq Rappel',
          'changed_associates': 'Associados',
          'changed_MTKG': 'MKTG',
          'virtual_signed': 'Consentimiento digital',
          'virtual_signApproved': 'Consentimento aprovado',
          'has_email_invoices': '¿desea fra electrónica?',
          'email_invoices_1': 'mail fra electrónica 1',
          'email_invoices_2': 'mail fra electrónica 2',
          'changed_booleans': {
            'yes': 'Si',
            'no': 'No'
          },
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        }
      },
      'sda': {
        'sda_list': 'Relatório SDA',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'export': {
          'no_data': 'Você deve selecionar pelo menos um SDA'
        },
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'sda_sp': 'SDA System Professional',
          'sda_sp_internet': 'SDA SP Internet',
          'sda_sp_men': 'SDA SP Men',
          'sda_system_ec': 'SDA System EC',
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_internet': 'SDA Sebastian Internet',
          'sda_ghd': 'SDA GHD',
          'sda_wedo': 'SDA Wedo',
          'sp_date': 'SP Data',
          'sp_internet_date': 'SP Internet Data',
          'sp_men_date': 'SP Men Data',
          'sp_system_ec_date': 'System EC Data',
          'sebastian_date': 'Sebastian Data',
          'sebastian_internet_date': 'Sebastian Internet Data',
          'sda_ghd_date': 'SDA GHD Data',
          'sda_wedo_date': 'SDA Wedo Data',
          'sda_date': 'SDA Data Ult',
          'normal_sda_pdf': 'SDA PDF',
          'system_ec_sda_pdf': 'SDA System EC PDF',
          'sebastian_sda_pdf': 'SDA Sebastian PDF',
          'sda_link_pdf': 'Veja PDF',
          'sda_pdf': 'Veja PDF SDA',
          'sda_wedo_pdf': 'Veja PDF SDA Wedo',
          'sda_sassoon': 'SDA Sassoon',
          'sassoon_date': 'Sassoon Data',
          'sp_diamond': 'SP Diamond Data',
          'sda_sp_diamond_pdf': 'Veja PDF SDA SP Diamond',
          'sda_sp_diamond': 'SDA SP Diamond'
        }
      },
      'potential': {
        'potential_list': 'Relatório Potencial',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'employees_quantity': 'Número de empregados',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial SP Diamond',
          'opi_potential': 'Potencial OPI'
        }
      },
      'cci': {
        'cci_list': 'Relatório CCI',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social',
          'image_conditions': 'Condições de imagem'
        }
      },
      'education': {
        'education_list': 'Relatório Educação',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'email': 'Correo electrónico',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'wella_quantity': 'Wella cantidad',
          'wella_package': 'Pacote Wella',
          'sp_quantity': 'System cantidad',
          'sp_package': 'Pacote System',
          'nioxin_quantity': 'Nioxin cantidad',
          'nioxin_package': 'Pacote Nioxin',
          'sebastian_quantity': 'Sebastian cantidad',
          'sebastian_package': 'Pacote Sebastian',
          'sassoon_quantity': 'Sassoon cantidad',
          'sassoon_package': 'Pacote Sassoon',
          'salons': 'Quartos',
          'mkt_news': 'Condições de correio'
        }
      }
    },
    'history': {
      'header': {
        'contracts_list': 'Contratos',
        'contracts_sda_list': 'SDA'
      },
      'contracts': {
        'contracts_history': 'Histórico',
        'create_histrory': 'Criar histórico',
        'export_contracts': 'Contratos de exportação',
        'export_zip_pdfs': 'Exportar PDFs Zip',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'selectYears': 'Ano',
        'filters': {
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Status',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'since': 'De',
          'until': 'Para cima',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social'
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'timestamp': 'Timestamp',
          'seller': 'VENDEDORES',
          'client': 'CLIENTES',
          'associated': 'ASSOCIADOS',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'associated_code': 'Código',
          'associated_cif': 'NIF',
          'associated_email': 'Correio eletrônico',
          'associated_legal_name': 'Razão social',
          'associated_employees': 'Empregados',
          'observations': 'Observações',
          'prorated': '¿Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses rateados',
          'manual_date': 'Data Manual',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'pdf': 'Veja PDF',
          'salons': 'SALÕES',
          'premium': 'PREMIUM',
          'premium_agreement': 'Premium Acordo',
          'premium_ATS': 'Premium ATS',
          'premium_Brands': 'Premium Marcas',
          'premium_MTKG': 'Premium Pacote de Apoio',
          'premium_rappel_1': 'Premium % RAPPEL Escalada 1',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing 1',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_variable_discount_1': 'Premium Dto Variável 1',
          'premium_variable_discount_2': 'Premium Dto Variável 2',
          'premium_salon': 'Premium Tipo de Cliente',
          'premium_education': 'Premium Educação',
          'premium_potential': 'Premium Potencial',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_date': 'Data',
          'premium_salon_value': 'Valor do salão',
          'premium_MTKG_Subtype': 'Premium Pacote de Apoio Seleção',
          'premium_section_1': 'Premium Section 2',
          'premium_section_2': 'Premium Section 2',
          'premium_discount_1': 'PremiumDesconto 1',
          'premium_discount_2': 'PremiumDesconto 2',
          'prestige': 'PRESTIGE',
          'prestige_agreement': 'Prestige ACUERDO',
          'prestige_ATS': 'Prestige ATS',
          'prestige_Brands': 'Prestige MARCAS',
          'prestige_MTKG': 'Prestige Pacote de Apoio',
          'prestige_salon': 'Prestige Tipo de Cliente',
          'prestige_education': 'Prestige Educação',
          'prestige_potential': 'Prestige Potencial',
          'prestige_rappel_1': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing 1',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'Prestige RAPPEL Freqüência',
          'prestige_variable_discount_1': 'Prestige Dto Variável 1',
          'prestige_variable_discount_2': 'Prestige Dto Variável 2',
          'prestige_discount_total': 'Prestige DTO (TOTAL)',
          'prestige_date': 'Data',
          'prestige_salon_value': 'Valor do salão',
          'prestige_MTKG_Subtype': 'Prestige Pacote de Apoio Seleção',
          'prestige_section_1': 'Prestige Section 2',
          'prestige_section_2': 'Prestige Section 2',
          'prestige_discount_1': 'PrestigeDesconto 1',
          'prestige_discount_2': 'PrestigeDesconto 2',
          'iso': 'ISO',
          'wella': 'WELLA',
          'wella_quantity': 'Wella quantidade',
          'wella_support': 'Wella apoio',
          'wella_discount': 'Desconto',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'rappel_antecipado': 'Rappel antecipado',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'nioxin_quantity': 'Nioxin quantidade',
          'nioxin_support': 'Nioxin apoio',
          'sp_quantity': 'SP quantidade',
          'sp_support': 'SP apoio',
          'system_ec_quantity': 'System EC quantidade',
          'system_ec_support': 'System EC apoio',
          'sebastian_quantity': 'Sebastian quantidade',
          'sebastian_support': 'Sebastian apoio',
          'sebastian_brand_rappel': 'Sebastian rappel acordo',
          'sebastian_growth_rappel': 'Sebastian rappel crescimento',
          'sebastian_total_rappel': 'Sebastian rappel total',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'system_ec_potential': 'Potencial System EC',
          'sebastian_potential': 'Potencial Sebastian',
          'seb_man_rappel': 'Rappel Nioxin/Sebman',
          'seb_man_discount': 'Desconto Nioxin/Sebman',
          'wella_date': 'Data',
          'wella_salon': 'Salão',
          'wella_rappel': 'Rappel',
          'wella_variable_discount': 'DTO Variable',
          'wella_trade': 'Trade',
          'sp': 'SYSTEM',
          'sp_date': 'Data',
          'sp_salon': 'Salon',
          'sp_discount': 'DTO',
          'sp_rappel': 'Rappel',
          'sp_variable_discount': 'DTO Variable',
          'sebastian': 'SEBASTIAN',
          'sebastian_date': 'Data',
          'sebastian_salon': 'Salon',
          'sebastian_discount': 'DTO',
          'sebastian_rappel': 'Rappel',
          'sassoon': 'SASSON',
          'sassoon_date': 'Data',
          'sassoon_quantity': 'Professional',
          'sassoon_salon': 'Salon',
          'sassoon_discount': 'DTO',
          'sassoon_rappel': 'Rappel',
          'sassoon_potential': 'Potencial',
          'sp_diamond': 'SP DIAMOND',
          'sp_diamond_date': 'Data',
          'sp_diamond_quantity': 'Professional',
          'sp_diamond_salon': 'Salon',
          'sp_diamond_discount': 'DTO',
          'sp_diamond_rappel': 'Rappel',
          'sp_diamond_potential': 'Potencial',
          'nioxin': 'NIOXIN',
          'nioxin_date': 'Data',
          'nioxin_salon': 'Salon',
          'nioxin_discount': 'DTO',
          'nioxin_summer_discount': 'DTO Verano',
          'nioxin_rappel': 'Rappel',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_discount': 'DTO',
          'opi_rappel': 'Rappel Opi',
          'opi_potential': 'Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'comments': 'Comentarios',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mail_conditions': 'Condições de correio',
          'mail_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'image_conditions': 'Condiciones imagen',
          'image_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea archivar este contrato?'
        },
        'contracts_history_create': 'Crear historial',
        'client_not_have_relations': 'Este cliente não possui associações',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial y descuentos',
        'observations': 'Observaciones',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'associate_accounts': 'Asociar cuentas',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses prorrateados',
          'manual_date': 'Data Manual',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'pdf': 'Agregar archivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          },
          'wella_date': 'Wella Data',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Wella Descuento',
          'wella_rappel': 'Wella Rappel',
          'wella_potential': 'Wella Potencial',
          'wella_variable_discount': 'Wella Descuento Variable',
          'wella_trade': 'Wella Trade',
          'sp_date': 'System Data',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'System Descuento',
          'sp_rappel': 'System Rappel',
          'sp_potential': 'System Potencial',
          'sp_variable_discount': 'System Descuento Variable',
          'sp_diamond_date': 'SP Diamond Data',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Diamond Descuento',
          'sp_diamond_rappel': 'Diamond Rappel',
          'sp_diamond_potential': 'Diamond Potencial',
          'sebastian_date': 'Sebastian Data',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Sebastian Descuento',
          'sebastian_rappel': 'Sebastian Rappel',
          'sebastian_potential': 'Sebastian Potencial',
          'sassoon_date': 'Sassoon Data',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Sassoon Descuento',
          'sassoon_rappel': 'Sassoon Rappel',
          'sassoon_potential': 'Sassoon Potencial',
          'nioxin_date': 'Nioxin fecha',
          'nioxin_quantity': 'Nioxin Professional',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_discount': 'NioxinDescuento',
          'nioxin_summer_discount': 'Nioxin Desc. Verano',
          'nioxin_rappel': 'Nioxin Rappel',
          'nioxin_potential': 'Nioxin Potencial',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Opi Descuento',
          'opi_rappel': 'Opi Rappel',
          'opi_potential': 'Opi Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'create_button': 'Crear contrato',
        'create_success': 'Contrato creado con éxito',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito',
        'export_zip_pdfs_window': {
          'title': 'Descargar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'download_button': 'descargar zip'
        },
        'create_history_window': {
          'title': 'Crear Historial',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'start_button': 'Generar Histrorial'
        },
        'message': {
          'status': {
            'finalized': 'Proceso finalizado con exito'
          }
        }
      },
      'sda': {
        'sda_list': 'Contratos SDA',
        'create_contract_sda': 'Criar contrato SDA',
        'export_zip_pdfs': 'Exportar Zip PDFs',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Não exportado'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'sda_sp': 'SDA System Professional',
          'sda_sp_options': {
            'ok': 'ok'
          },
          'sda_sp_internet': 'SDA SP Internet',
          'sda_sp_internet_options': {
            'ok': 'ok'
          },
          'sda_sp_men': 'SDA SP Men',
          'sda_sp_men_options': {
            'ok': 'ok'
          },
          'sda_system_ec': 'SDA System EC',
          'sda_system_ec_options': {
            'ok': 'ok'
          },
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_options': {
            'ok': 'ok'
          },
          'sda_sebastian_internet': 'SDA Sebastian Internet',
          'sda_sebastian_internet_options': {
            'ok': 'ok'
          },
          'sda_ghd': 'SDA GHD',
          'sda_ghd_options': {
            'ok': 'ok'
          },
          'sda_wedo': 'SDA Wedo',
          'sda_wedo_options': {
            'ok': 'ok'
          },
          'sp_date': 'SP Data',
          'sp_internet_date': 'SP Internet Data',
          'sp_men_date': 'SP Men Data',
          'sp_system_ec_date': 'System EC Data',
          'sebastian_date': 'Sebastian Data',
          'sebastian_internet_date': 'Sebastian Internet Data',
          'sda_ghd_date': 'SDA GHD Data',
          'sda_wedo_date': 'SDA Wedo Data',
          'sda_date': 'SDA Data Ult',
          'normal_sda_pdf': 'SDA PDF',
          'system_ec_sda_pdf': 'SDA System EC PDF',
          'sebastian_sda_pdf': 'SDA Sebastian PDF',
          'sda_wedo_pdf': 'Ver PDF SDA Wedo',
          'sda_link_pdf': 'Ver PDF',
          'normal_sda_virtual_signed': 'SDA Consentimiento digital',
          'system_ec_sda_virtual_signed': 'SDA System EC Consentimiento digital',
          'wedo_sda_virtual_signed': 'SDA Wedo Consentimiento digital',
          'sebastian_sda_virtual_signed': 'SDA Sebastian Consentimiento digital',
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Contrato de arquivo'
        },
        'create_contract_window': {
          'title': 'Criar contrato SDA',
          'fields': {
            'client': 'Cliente',
            'sda_types': 'Tipos de SDA',
            'sda_types_options': {
              'sda_sp': 'SDA SP',
              'sda_sp_internet': 'SDA SP Internet',
              'sda_sp_men': 'SDA SP Men',
              'sda_system_ec': 'SDA System EC',
              'sda_sebastian': 'SDA Sebastian',
              'sda_sebastian_internet': 'SDA Sebastian Internet',
              'sda_ghd': 'SDA GHD',
              'sda_wedo': 'SDA Wedo'
            },
            'date': 'Data',
            'pdf': 'Adicionar arquivo PDF',
            'pdf_sp_diamond': 'Adicionar arquivo PDF Sp Diamond'
          },
          'create_button': 'Criar contrato SDA',
          'create_success': 'Contrato SDA criado com sucesso'
        },
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado com sucesso',
        'archive_success': 'Contrato arquivado com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Posso',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Año'
          },
          'download_button': 'baixar zip'
        }
      }
    }
  },
  'utils': {
    'frequency': {
      'quarterly': 'trimestral',
      'biannual': 'semestre',
      'annual': 'anual'
    },
    'conditional': {
      'yes': 'Sim',
      'not': 'Ñao'
    },
    'type_client': 'Tipo de Cliente'
  }
}



// WEBPACK FOOTER //
// ./src/locales/pt.js